import { useQuery } from '@apollo/client';
import AppBar from '@mui/material/AppBar';
import { makeStyles } from 'tss-react/mui';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import useMediaQuery from '@mui/material/useMediaQuery';
import EditIcon from '@mui/icons-material/Edit';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { GET_AUTHOR_POST_LOCATIONS } from '../../helpers/graphql/posts';
import { getUser } from '../../helpers/token';
import Link from '@mui/material/Link';
import OpacityBtn from '../General/OpacityBtn';
import FollowButton from './FollowButton';
import ProfileTabs from './ProfileTabs';
import { GET_ITINERARIES } from '../../helpers/graphql/itineraries';
import { grey } from '@mui/material/colors';
import graphQLClient from 'helpers/graphQLClient';

const a11yProps = index => {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
};

const useStyles = makeStyles()(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.dark,
  },
  tab: {
    color: grey[300],
    '&.Mui-selected': {
      color: grey[100],
    },
  },
}));

const LinkTab = props => {
  const { classes } = useStyles();

  return (
    <Tab
      className={classes.tab}
      component="a"
      onClick={event => {
        event.preventDefault();
      }}
      {...props}
    />
  );
};

const Profile = props => {
  const { classes } = useStyles();
  const [value, setValue] = React.useState(props.tabValue || 0);
  const [countryCodes, setCountryCodes] = React.useState(undefined);
  const [authorPostLocations, setAuthorPostLocations] = React.useState([]);

  const handleChange = (event, newValue) => {
    history.pushState(
      null,
      '',
      `/@${profile.author.username}${
        newValue === 1 ? '/map' : newValue === 2 ? '/itineraries' : ''
      }`,
    );
    setValue(newValue);
  };
  const { profile } = props;
  const author = profile.author.username;

  const renderFollowTab = useMediaQuery('(min-width: 768px)');

  useEffect(() => {
    graphQLClient(GET_AUTHOR_POST_LOCATIONS, {
      author,
    })
      .then(data => {
        if (data && data.posts && data.posts.length > 0) {
          setAuthorPostLocations(data.posts);
          const newCountryCodes = [];
          if (data.posts && data.posts.length > 0) {
            data.posts.forEach(d => {
              if (
                d.location &&
                d.location.countryCode &&
                newCountryCodes.indexOf(d.location.countryCode) === -1
              )
                newCountryCodes.push(d.location.countryCode);
            });
          }
          setCountryCodes(newCountryCodes);
        } else setCountryCodes([]);
      })
      .catch(err => {
        console.log(err);
        setCountryCodes([]);
      });
  }, [props]);

  const userItineraries = useQuery(GET_ITINERARIES, {
    variables: { username: author },
  });

  const itineraries =
    userItineraries && userItineraries.data && userItineraries.data.itineraries;

  return (
    <>
      <div className={classes.root}>
        <AppBar position="static" color="primary" enableColorOnDark>
          <div className="container">
            <Tabs
              variant="fullWidth"
              value={value}
              onChange={handleChange}
              aria-label="nav tabs example"
              textColor="secondary"
              indicatorColor="secondary"
            >
              <LinkTab label="Blog" {...a11yProps(0)} />
              <LinkTab label="Map" {...a11yProps(1)} />
              {itineraries && itineraries.length > 0 && (
                <LinkTab label="Itineraries" {...a11yProps(2)} />
              )}
              {renderFollowTab && (
                <>
                  {getUser() === profile.author.username ? (
                    <Link href="/dashboard/profile">
                      <OpacityBtn>
                        <EditIcon />
                        <span className="pl-1">Edit Profile</span>
                      </OpacityBtn>
                    </Link>
                  ) : (
                    <FollowButton
                      author={profile.author.username}
                      btnstyle="solid"
                      opacityBtn
                    />
                  )}
                </>
              )}
            </Tabs>
          </div>
        </AppBar>
        {countryCodes ? (
          <ProfileTabs
            isMini={props.isMini}
            itineraries={itineraries}
            profile={profile}
            value={value}
            countryCodes={countryCodes}
            userPosts={authorPostLocations}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

Profile.propTypes = {
  author: PropTypes.string,
};

// eslint-disable-next-line import/no-unused-modules
export default Profile;
